<div class="mb-4">
  <bn-web-ui-card heading="Historical event logs">
    <div class="chart-container position-relative">
      <bn-chart-single-metric
        [chartConfig]="{ summaryLabelKey: 'WAFAttacks', summaryLabelText: 'Total WAF triggers' }"
        [data]="chartData ? chartData() : []"
        [summaryLabels]="chartSummaryLabels" />
      @if (!chartHasData) {
        <div class="chart-overlay">
          <span>There is no attack data to show yet.</span>
        </div>
      }
    </div>
  </bn-web-ui-card>
</div>

@if (triggeredRules() === null || triggeredRules()?.length) {
  <div class="bn-table bn-table--auto bn-table--primary">
    <table class="bn-table--normal">
      <tbody class="text-bunny-dark">
        @if (triggeredRules() !== null) {
          @for (rule of triggeredRules(); track rule; let index = $index) {
            <tr
              class="cursor-pointer"
              (click)="onRowClick(rule.ruleId)">
              <td>
                <span class="text-200-semi-bold">{{ rule.ruleDescription || '' }}</span>
              </td>
              <td class="text-end"><fa-icon icon="chevron-right" /></td>
            </tr>
          }
        } @else {
          @for (item of [].constructor(5); track $index) {
            <tr>
              @for (item of [].constructor(6); track $index) {
                <td>
                  <ngx-skeleton-loader [theme]="{ 'width.%': 75, 'margin-bottom': 0, height: '18px', 'margin-top': '3px' }" />
                </td>
              }
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
} @else {
  <!-- // TODO: Note: appropriate text and image, maybe add button for adding new -->
  <bn-web-ui-not-available
    [options]="{
      title: 'No rules to review',
      description: 'No WAF rules have been triggered for this zone yet. Check back later once it receives more requests.',
      size: 'lg',
      imageOptions: {
        fileName: 'bunny-no-triggered-rules.svg',
        height: '140px',
        right: '-130px',
      },
    }" />
}

<bn-web-ui-side-content
  [show]="showSideContent"
  (closeAction)="onSideContentClose()">
  <app-app-shield-waf-triggered-rules-slideout
    [rulesCount]="triggeredRulesInternal.length"
    [selectedRuleIndex]="selectedRuleIndex"
    [triggeredRule]="triggeredRule"
    (directionClick)="onDirectionClick($event)" />
</bn-web-ui-side-content>
